import { useEffect, useState } from "react";
import { CombinedRequestCell } from ".";
import { formatDate } from "@/utils/dateUtils";
import { translate } from "@/utils/langUtils";
import { CRRender } from "@/components/crRender";
import { PATIENT_REQUEST_STATUS } from "@/data/status";

export const DateRequestCell = ({ original }) => {


    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
        if (!original.orderDate) return;

        const expireDate = new Date(original.orderDate);
        expireDate.setHours(expireDate.getHours() + (original.sla || 72));

        const updateCountdown = () => {
            const now = new Date();
            const diff = expireDate - now;


            if (diff <= 0) return setTimeLeft(`${translate("remains")} --:--:--`)


            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            setTimeLeft(
                `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
            );
        };

        updateCountdown();

        const interval = setInterval(updateCountdown, 1000);

        return () => clearInterval(interval);
    }, [original.orderDate]);


    return (
        <CombinedRequestCell main={formatDate(original.orderDate)} sub={original.orderStatusId == PATIENT_REQUEST_STATUS?.Pending ? timeLeft : ""} mainClassName='date-request-cell' subClassName='sla-request-cell' />
    )

}
